module.exports = __webpack_public_path__ + "static/media/stmarysLogo.e4113a2c.jpg";